"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    require("../index").default.name
];



//////////////////
// WEBPACK FOOTER
// ./dist/app-importer.generated.js
// module id = 2272
// module chunks = 0